/* globals $:false */
import Select from './recordm.fields.select.js';

// Component capable of handling selection lists with a radio group
// Extends Select
//
// args:
// * `options`: A list of possible values
// * `confs`: the field configuration
//
// confs:
// * `id`: the input attr id
// * `cssClasses`: A string space separated with a list of css classes to add to the surrounding rediogroup div
// * `readonly`: true or false. Defaults to false
// * `valueChanged(newValue)`: Invoked when a user changes the value,
//
// * `defaultValue`: The default selected option
// * `allowEmptyOption`: If there is an empty option
//
var Multiple = function(core) {
    this._core = core;

    /* eslint-disable-next-line prefer-rest-params */
    Select.apply(this, arguments);

    this._$checkboxes = [];
    this._groupName = "checkboxgroup_" + this._confs.id;
};


Multiple.prototype = new Select();
Multiple.prototype.constructor = Multiple;


Multiple.prototype.render = function() {
    var _this = this;

    var $html = $([
        '<div class="radiogroup ' + _this._groupName + ' field-value">',
        '</div>'
    ].join(''));

    this._$input = $html;

    if (this._confs.cssClasses) {
        this._$input.addClass(this._confs.cssClasses);
    }

    this._options.forEach(function(option) {
        _this._$input.append($('<label class="radio-inline">' +
                              '<input type="checkbox" name="' + _this._groupName + '" value="' + option + '">' + option +
                              '</label>'));
    });

    if (this._confs.allowEmptyOption) {
        this._$input.append($('<a class="link js-clear-radio" >' +
                              this._core.translateString("recordm.instances", "instance.field.radio.clear") +
                              '</a>'));

        $(".js-clear-radio", this._$input).on('click', function() {
            _this._$checkboxes.prop('checked', false);
            _this.setValue("");
        });
    }

    this._$checkboxes = $("input[name='" + _this._groupName + "']", this._$input);

    if (this._confs.defaultValue && this._lastValue === undefined) {
       _this._setValue(_this._confs.defaultValue);
    }

    if (this._confs.readonly) {
        this._$checkboxes.attr("disabled", "disabled").attr("tabindex", -1);
    } else {
        this._$checkboxes.on('change', function(){_this._onValueChange()});
    }

    if (this._lastValue) {
        _this.setValue(this._lastValue);

    } else {
        this._lastValue = this._$checkboxes.filter(":checked")
            .map(function(idx, el){ return el.value}).get().join('\0');
    }

    return $html;
};

Multiple.prototype.destroy = function() {
    var _this = this;

    if (!this._confs.readonly) {
        this._$checkboxes.off('change', function(){_this._onValueChange()});
    }
};

Multiple.prototype._setFieldValue = function(value) {
    // Notify that this field has a new value because
    // I want to update the $auto.join and other fields...
    this._setValue(Array.isArray(value) ? value.join("\0") : value);
}

Multiple.prototype.setValue = function(values) {
    if (this._$input) {
        // Clear previous values before setting new values
        $('input[name="' + this._groupName + '"]', this._$input).prop('checked', false)

        const arValues = Array.isArray(values) ? values : values.split("\0")
        arValues.forEach(function (value) {
            $('input[name="' + this._groupName + '"][value="' + value + '"]', this._$input).prop('checked', true);
        }.bind(this))
    }

    // Notify that this field has a new value because
    // I want to update the $auto.join and other fields...
    this._setFieldValue(values)
};

Multiple.prototype._onValueChange = function() {
    var value = this._$checkboxes.filter(":checked").map(function(_idx, el){ return el.value}).get().join('\0');
    this._setFieldValue(value)
};

Multiple.getValueOf = function($instance, radioGroupName) {
    return $instance.find("input[name='"+radioGroupName +"']:checked").map(function(_idx, el){ return el.value}).get().join('\0');
};

Multiple.prototype.disableSelf = function() {
    this._$checkboxes.prop("disabled", true).attr("tabindex", -1);
    $(".js-clear-radio", this._$input).addClass("hidden");
};

Multiple.prototype.enableSelf = function() {
    this._$checkboxes.removeProp("disabled").removeAttr("tabindex");
    $(".js-clear-radio", this._$input).removeClass("hidden");
};

export default Multiple;
